import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveSupportedLanguage } from '@/i18n/config';

export function useDirection() {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const lang = resolveSupportedLanguage(i18n.resolvedLanguage ?? i18n.language);
    const dir = lang.dir ?? 'ltr';

    return { dir, isRtl: dir === 'rtl' } as const;
  }, [i18n.language, i18n.resolvedLanguage]);
}
